import React from 'react';
import { Link } from 'react-router-dom';
import { Cursor, useTypewriter } from 'react-simple-typewriter';
import BackgoundCircles from './Backgroundcircles';
import Stats from './Stats';

function Hero({ role, heroImage }) {
  const [text, count] = useTypewriter({
    words: [
      'Hello , I Am <Jackon/>',
      'i-heart-swimming.js',
      '<butNotMoreThanCodes/>',
    ],
    loop: true,
    delaySpeed: 2000,
  });
  return (
    <div className="h-screen flex flex-col space-y-8 items-center justify-center  text-center overflow-hidden ">
      <BackgoundCircles />
      <Stats />
      <img
        src={heroImage}
        alt="profile"
        className="relative rounded-full h-32 w-32 mx-auto object-cover"
      />
      <div className="z-20">
        <h2 className="text-[8px] font-bold uppercase tracking-[10px] text-gray-600 ">
          {role}
        </h2>
        <h1>
          <span className="font-semibold text-xl sm:text-xl tracking-widest">
            {text}
          </span>
          <Cursor cursorColor="#5bccf6" />
        </h1>
        <div className="mt-16 md:mt-24">
          <a href="#about">
            <a className="heroNavButtons">About</a>
          </a>
          <a href="#skills">
            <a className="heroNavButtons">Skills</a>
          </a>
          <a href="#projects">
            <a className="heroNavButtons">Projects</a>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Hero;
